/*
 * CohortEnrollments Messages
 *
 * This contains all the text for the CohortEnrollments component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.enrollments';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Enrollments',
  },
  enrollStudents: {
    id: `${scope}.dialogTitle`,
    defaultMessage: 'Enroll Students',
  },
  enrollStudentsPlaceholder: {
    id: `${scope}.enrollStudentsPlaceholder`,
    defaultMessage: 'Type names or emails to enroll',
  },
  noResults: {
    id: `${scope}.noResults`,
    defaultMessage: 'No Results',
  },
});
